import { render, staticRenderFns } from "./Recepcion0kmDanos.vue?vue&type=template&id=1e20dafd&scoped=true"
import script from "./Recepcion0kmDanos.vue?vue&type=script&lang=js"
export * from "./Recepcion0kmDanos.vue?vue&type=script&lang=js"
import style0 from "./Recepcion0kmDanos.vue?vue&type=style&index=0&id=1e20dafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20dafd",
  null
  
)

export default component.exports